// Display helpers used by the search UI. Pure functions; no DOM mutation.
import { normalizeHe } from "./search-core";
import type { Lang } from "./types";

export function highlightSnippet(text: string, terms: string[], lang: Lang, ctx = 120): string {
  if (!text || terms.length === 0) return truncate(text, ctx * 2);
  const norm = (s: string) => lang === "he" ? normalizeHe(s) : s.toLowerCase();
  const lowered = norm(text);
  let bestIdx = -1, bestTerm = "";
  for (const t of terms) {
    const nt = norm(t);
    const i = lowered.indexOf(nt);
    if (i >= 0 && (bestIdx < 0 || i < bestIdx)) { bestIdx = i; bestTerm = nt; }
  }
  if (bestIdx < 0) return truncate(text, ctx * 2);
  const start = Math.max(0, bestIdx - ctx);
  const end = Math.min(text.length, bestIdx + bestTerm.length + ctx);
  let snippet = text.slice(start, end);
  if (start > 0) snippet = "…" + snippet;
  if (end < text.length) snippet = snippet + "…";
  return snippet;
}

function truncate(s: string, n: number): string {
  if (!s) return "";
  return s.length <= n ? s : s.slice(0, n) + "…";
}

export function markup(text: string, terms: string[], lang: Lang): string {
  const escaped = text.replace(/[&<>]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]!));
  if (terms.length === 0) return escaped;
  const norm = (s: string) => lang === "he" ? normalizeHe(s) : s;
  const escapedTerms = terms
    .map(norm)
    .filter(Boolean)
    .map(t => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  if (!escapedTerms.length) return escaped;
  const re = new RegExp(`(${escapedTerms.join("|")})`, lang === "he" ? "g" : "gi");
  return escaped.replace(re, "<mark>$1</mark>");
}
